import type { FC } from "react";
import { twMerge } from "tailwind-merge";

import type { BlockVariantType } from "../../../../../collaboration/src/shared/types/worksheet";

import { t } from "i18n/i18n";
import { SquareIconButton } from "mds/components/buttons/SquareIconButton";
import { TrashDeleteIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectIsEditModeEnabled } from "store/selectors";

interface BlockToolbarProps {
  className?: string;
  blockType: BlockVariantType;
  onDelete: () => void;
  children?: React.ReactNode;
}

export const BlockToolbar: FC<BlockToolbarProps> = ({
  className,
  blockType,
  onDelete,
  children,
}) => {
  const isEditModeEnabled = useAppSelector(selectIsEditModeEnabled);
  return (
    // z-index should be above `Block` (which is 1) to enable proper
    // visibility and interaction with the toolbar.
    <div
      className={twMerge(
        "block-toolbar absolute left-full z-[2] ml-1 flex flex-col items-center gap-1",
        isEditModeEnabled ? "-mr-10" : "",
        className,
      )}
      role="toolbar"
    >
      {children}
      {isEditModeEnabled && onDelete && (
        <SquareIconButton
          eventName="Content block - Delete"
          eventProps={{ blockType }}
          kind="caution"
          size="s"
          title={t("tooltip.delete_block")}
          onClick={onDelete}
        >
          <TrashDeleteIcon />
        </SquareIconButton>
      )}
      {/* TODO: The Delete button should be moved into the "..." menu along with a "Duplicate" functionality.
          Removing the ... menu for now to simulate how it feels with the # of buttons it will have in the end.
       */}
      {/* <LegacyButton */}
      {/*  kind="secondary" */}
      {/*  size="s" */}
      {/*  iconOnly */}
      {/*  onClick={() => { */}
      {/*    alert("Coming soon"); */}
      {/*  }} */}
      {/* > */}
      {/*  <DotMenuVerticalIcon /> */}
      {/* </LegacyButton> */}
    </div>
  );
};
